import React, { useState, useEffect } from 'react';
import { useLanguage } from './LanguageContext';
import { API_URL } from '../utils/api';

const VerifyEmail = ({ token, onNavigate }) => {
  const { print_lang } = useLanguage();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      // console.log('Verifying email with token:', token ? token.substring(0, 10) + '...' : 'null');

      try {
        const response = await fetch(`${API_URL}/api/admin/verify-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });

        // console.log('Verify response status:', response.status);
        const data = await response.json();
        // console.log('Verify response data:', data);

        if (data.success) {
          setStatus('success');
          setMessage(data.message || 'Email verified successfully!');
        } else {
          setStatus('error');
          setMessage(data.message || 'Verification failed');
        }
      } catch (err) {
        console.error('Verification error:', err);
        setStatus('error');
        setMessage('Connection error. Please try again.');
      }
    };

    if (token) {
      verifyEmail();
    } else {
      // console.log('No token found in URL');
      setStatus('error');
      setMessage('Invalid verification link - no token found');
    }
  }, [token]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          {status === 'verifying' && (
            <>
              <div className="auth-logo-icon">
                <div className="spinner" style={{ width: '2rem', height: '2rem', borderTopColor: 'white' }} />
              </div>
              <h1 className="auth-logo-title">{print_lang('auth.verifying', 'Verifying...')}</h1>
              <p className="auth-logo-subtitle">Please wait while we verify your email</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="auth-logo-icon" style={{ backgroundColor: '#10b981' }}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <h1 className="auth-logo-title">{print_lang('auth.verified', 'Email Verified!')}</h1>
              <p className="auth-logo-subtitle">{message}</p>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="auth-logo-icon" style={{ backgroundColor: '#ef4444' }}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
              </div>
              <h1 className="auth-logo-title">{print_lang('common.error', 'Error')}</h1>
              <p className="auth-logo-subtitle">{message}</p>
            </>
          )}
        </div>

        {status !== 'verifying' && (
          <div className="auth-links" style={{ marginTop: '1.5rem' }}>
            <a href="#login" onClick={(e) => { e.preventDefault(); onNavigate('login'); }}>
              {print_lang('auth.backToLogin', 'Back to Login')}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
